import {Box, Typography} from "@mui/material";
import React from "react";
import {useLanguage} from "../../LanguageContext";
import {useNavigation} from "../../NavigationProvider";
import {menuItems} from "../TopMenu";

const FooterMenu = () => {
    const {handleNavigation} = useNavigation();
    const {t} = useLanguage();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                color: 'white'
                // gap: 2,
            }}
        >
            {menuItems.map((item, index) => (
                <Box
                    key={index}
                >
                    <Typography
                        onClick={() => handleNavigation(item.path)}
                        align={'left'}
                        sx={{
                            pr: '20px',
                            cursor: 'pointer',
                            color: 'inherit',
                            textDecoration: 'none',
                            paddingTop: '5px',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        {t(item.label)}
                    </Typography>
                </Box>
            ))}
            <Typography
                onClick={() => window.open('https://www.instagram.com/ar.endezvous?igsh=enNpOXJtbXBzenpl', '_blank', 'noopener,noreferrer')}
                align={'left'}
                sx={{
                    cursor: 'pointer',
                    color: 'inherit',
                    textDecoration: 'none',
                    paddingTop: '5px',
                    '&:hover': {
                        textDecoration: 'underline',
                    },
                }}
            >
                Instagram
            </Typography>
        </Box>
    );
}


export default FooterMenu;
